import * as React from "react";
const SvgFiRrBoxCircleCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-box-circle-check_svg__a)">
      <path
        fill="#062147"
        d="M20 0H4C1.794 0 0 1.794 0 4v1c0 .886.387 1.684 1 2.234V19c0 2.757 2.243 5 5 5h3a1 1 0 0 0 0-2H6c-1.654 0-3-1.346-3-3V8h18v1a1 1 0 0 0 2 0V7.234c.613-.55 1-1.347 1-2.234V4c0-2.206-1.794-4-4-4M3 6c-.551 0-1-.449-1-1V4c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2v1c0 .551-.449 1-1 1zm14 4c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m3.221-6.212a1 1 0 0 1-.029 1.414l-2.212 2.124a2.35 2.35 0 0 1-1.653.671 2.37 2.37 0 0 1-1.664-.674l-1.132-1.107a1.001 1.001 0 0 1 1.4-1.43l1.132 1.108a.373.373 0 0 0 .522 0l2.223-2.134a1 1 0 0 1 1.414.029z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-box-circle-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoxCircleCheck;
